import { isCasinoTicket, isDepositTicket } from "./type";

export const normalizeDepositBarcode = (barcode) => parseInt(barcode.slice(1, barcode.length), 10);

export const normalizeCasinoBarcode = (barcode) => parseInt(barcode.slice(1, barcode.length), 10);

export const normalizeSportBarcode = (barcode) => (
  barcode.length === 20
    ? Number(barcode.slice(1, barcode.length - 7)) * 10
    : barcode
);

export const normalizeBarcode = (barcode) => {
  if (isCasinoTicket(barcode)) return normalizeCasinoBarcode(barcode);
  if (isDepositTicket(barcode)) return normalizeDepositBarcode(barcode);

  return normalizeSportBarcode(barcode);
};

export const removeBarcodeDuplicates = (longBarcode, minLengthOfBarcode = 11) => {
  const intersectionPart = longBarcode.slice(longBarcode.length - minLengthOfBarcode);
  const intersectionIndex = longBarcode.indexOf(intersectionPart);
  return `${longBarcode.slice(0, intersectionIndex)}${intersectionPart}`;
};
